export default "__VITE_ASSET__3c5e8b15__"